import React, { useEffect, useMemo, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || '';

function buildUrl(path) {
  return `${API_BASE.replace(/\/$/, '')}${path}`;
}

function imageSrc(path) {
  if (!path) return '';
  const p = String(path).trim();
  if (typeof window !== 'undefined' && p.startsWith('/uploads/')) {
    return window.location.origin + (p.startsWith('/') ? p : '/' + p);
  }
  return p;
}

function TourOne() {
  const categoryCards = useMemo(() => ([
    {
      slug: 'travel-with-dinesh',
      name: 'Travel With Dinesh',
      subtitle: 'සංචාරික වැඩසටහන්',
      fallbackImage: '/assets/img/destination/destination_1_3.jpg',
    },
    {
      slug: 'ape-pansala',
      name: 'Ape Pansala',
      subtitle: 'ධර්ම දේශනා වැඩසටහන',
      fallbackImage: '/assets/img/destination/destination_1_2.jpg',
    },
    {
      // Backend uses `urumaya` for this category
      slug: 'urumaya',
      name: 'Urumayahini News',
      subtitle: 'රටපුරා පුවත්',
      fallbackImage: '/assets/img/destination/destination_1_1.jpg',
    },
    {
      slug: 'ranga-rata',
      name: 'Ranga Rata',
      subtitle: 'සංස්කෘතික හා කලා වැඩසටහන්',
      fallbackImage: '/assets/img/destination/destination_1_4.jpg',
    },
  ]), []);

  const [videosByCategory, setVideosByCategory] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setLoading(true);
      try {
        const results = await Promise.all(
          categoryCards.map(async (c) => {
            const res = await fetch(buildUrl(`/api/videos?category=${encodeURIComponent(c.slug)}&limit=1`));
            const data = await res.json().catch(() => ({}));
            const video = data && data.success && Array.isArray(data.videos) ? data.videos[0] : null;
            return [c.slug, video];
          })
        );

        if (!cancelled) {
          setVideosByCategory(Object.fromEntries(results));
        }
      } catch (_e) {
        // Keep tiles with fallback images if API fails.
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => { cancelled = true; };
  }, [categoryCards]);

  return (
    <section
      className="tour-area position-relative bg-top-center overflow-hidden space bg-no-repeat"
      id="service-sec"
      style={{ backgroundImage: 'url(/assets/img/bg/tour_bg_1.jpg)' }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-6 offset-lg-3">
            <div className="title-area text-center">
              <span className="sub-title">Featured Videos</span>
              <h2 className="sec-title">Most Popular Videos</h2>
            </div>
          </div>
        </div>

        <div className="row g-4">
          {categoryCards.map((cat) => {
            const video = videosByCategory[cat.slug] || null;
            const thumb = video && video.thumbnail ? imageSrc(video.thumbnail) : cat.fallbackImage;
            const title = video && video.title ? video.title : cat.name;
            const href = video && video.url ? video.url : null;

            const Wrapper = href ? 'a' : 'div';
            const wrapperProps = href
              ? {
                  href,
                  target: '_blank',
                  rel: 'noopener noreferrer',
                }
              : { 'aria-disabled': true };

            return (
              <div key={cat.slug} className="col-md-6 col-lg-3">
                <Wrapper className="tour-location-card th-ani d-block position-relative" {...wrapperProps}>
                  <div className="tour-box_img global-img overflow-hidden rounded position-relative">
                    <img
                      src={loading ? cat.fallbackImage : thumb}
                      alt={cat.name}
                      className="w-100"
                      style={{ objectFit: 'cover', aspectRatio: '4/5' }}
                    />
                    <div
                      className="tour-location-overlay position-absolute bottom-0 start-0 end-0 p-3 text-white"
                      style={{ background: 'linear-gradient(transparent, rgba(0,0,0,0.7))' }}
                    >
                      <h4 className="box-title mb-0 text-white">{title}</h4>
                      <span className="small opacity-90">{cat.subtitle}</span>
                    </div>
                  </div>
                </Wrapper>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default TourOne;
